import { render } from "./batch_set_shop.vue?vue&type=template&id=0708a09e"
import script from "./batch_set_shop.vue?vue&type=script&lang=js"
export * from "./batch_set_shop.vue?vue&type=script&lang=js"

import "./batch_set_shop.vue?vue&type=style&index=0&id=0708a09e&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__